import React, { Component } from 'react';
import Modal from '../modal';
import { Mobile, Desktop } from '../../app-responsive';
import ArticleContent from '../article-content';
import Loader from '../loader';
import './article-modal.css';

class ArticleModal extends Component {
  constructor(props) {
    super(props);
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.state = {
      modalIsOpen: false,
    };
  }
  openModal() {
    this.setState({ modalIsOpen: true });
    const { articleId } = this.props;
    // fetch article content from AEM
    const { getArticleContent, getArticleDetail } = this.props.actions;
    getArticleContent({ articleId });
    getArticleDetail({ articleId });
  }

  closeModal() {
    this.setState({ modalIsOpen: false });
  }
  render() {
    const { contentLoading, linkText, articleContent } = this.props;
    const commonStyles = {
      bottom: 'auto',
      top: 'auto',
      left: 'auto',
      right: 'auto',
      position: 'relative',
      overflow: 'hidden',
      height: '100%',
    };
    const customStylesMobile = {
      content: {
        ...commonStyles,
      },
    };
    const customStylesDesktop = {
      content: {
        ...commonStyles,
        width: '982px',
        margin: '0 auto',
      },
    };
    const modalContent = customStyles => (
      <Modal
        isOpen={this.state.modalIsOpen}
        onRequestClose={this.closeModal}
        style={customStyles}
        ariaHideApp={false}
      >
        <div className="article-modal-content">
          {articleContent && !contentLoading ?
            <ArticleContent content={articleContent} /> : <Loader />
          }
        </div>
      </Modal>
    );

    return (
      <React.Fragment>
        <div className="read-more button clear left-aligned"><a role="link" onClick={this.openModal} tabIndex="0">{linkText}</a></div>
        <Mobile>
          {modalContent(customStylesMobile)}
        </Mobile>
        <Desktop>
          {modalContent(customStylesDesktop)}
        </Desktop>
      </React.Fragment>
    );
  }
}

export default ArticleModal;
